// extracted by mini-css-extract-plugin
module.exports = {"logo":"_1c9529d521--logo--GskWn","img":"_1c9529d521--img--xX7yr","title":"_1c9529d521--title--dTGfn","builder":"_1c9529d521--builder--Cveyh"};